import { AgentAction, EAgentActions } from '../actions/agent.action';
import { IAgentState, initialAgentState } from '../state/agent.state';

export function agentReducers(state = initialAgentState, action: AgentAction): IAgentState {
    switch (action.type) {
      
        case EAgentActions.GetAllAgentsSuccess: {
            return {
                ...state,
                getAllAgentsSuccess: action.payload,
                getAllAgentsError: null
            };
        }
        case EAgentActions.GetAllAgentsError: {
            return {
                ...state,
                getAllAgentsError: action.payload,
                getAllAgentsSuccess: null
            };
        }
        case EAgentActions.GetAddAgentSuccess: {
            return {
                ...state,
                getAddAgentSuccess: action.payload,
                getAddAgentError: null
            };
        }
        case EAgentActions.GetAddAgentError: {
            return {
                ...state,
                getAddAgentError: action.payload,
                getAddAgentSuccess: null
            };
        }
        case EAgentActions.GetImportAgentSuccess: {
            return {
                ...state,
                getImportAgentSuccess: action.payload,
                getImportAgentError: null
            };
        }
        case EAgentActions.GetImportAgentError: {
            return {
                ...state,
                getImportAgentError: action.payload,
                getImportAgentSuccess: null
            };
        }
        case EAgentActions.GetEditAgentSuccess: {
            return {
                ...state,
                getEditAgentSuccess: action.payload,
                getEditAgentError: null
            };
        }
        case EAgentActions.GetEditAgentError: {
            return {
                ...state,
                getEditAgentError: action.payload,
                getEditAgentSuccess: null
            };
        }
        case EAgentActions.GetDownloadFileSuccess: {
            return {
                ...state,
                getDownloadFileSuccess: action.payload,
                getDownloadFileError: null
            };
        }
        case EAgentActions.GetDownloadFileError: {
            return {
                ...state,
                getDownloadFileError: action.payload,
                getDownloadFileSuccess: null
            };
        }
        case EAgentActions.GetAgentInactiveSuccess: {
            return {
                ...state,
                getAgentInactiveSuccess: action.payload,
                getAgentInactiveError: null
            };
        }
        case EAgentActions.GetAgentInactiveError: {
            return {
                ...state,
                getAgentInactiveError: action.payload,
                getAgentInactiveSuccess: null
            };
        }
        case EAgentActions.GetAgentactiveSuccess: {
            return {
                ...state,
                getAgentactiveSuccess: action.payload,
                getAgentactiveError: null
            };
        }
        case EAgentActions.GetAgentactiveError: {
            return {
                ...state,
                getAgentactiveError: action.payload,
                getAgentactiveSuccess: null
            };
        }
        case EAgentActions.GetAgentsBystatusIdSuccess: {
            return {
                ...state,
                getAgentsBystatusIdSuccess: action.payload,
                getAgentsBystatusIdError: null
            };
        }
        case EAgentActions.GetAgentsBystatusIdError: {
            return {
                ...state,
                getAgentsBystatusIdError: action.payload,
                getAgentsBystatusIdSuccess: null
            };
        }
        default:
        return state;
}
}
